module.exports = __webpack_public_path__ + "img/hongbao_1_100.eb0b4f8c.png";